import React from 'react';
import { useCloseWindow } from '../../hooks/useCloseWindow';
import { useSelector } from 'react-redux';
import { selectConfigExpressSettingsName } from '../../store/slices/config/configSelectors';
import { selectCurrentFlow } from '../../store/slices/flow/flowSelectors';
import GeneralPageLayout from '../../components/layout/GeneralPageLayout';

/**
 * This components is meant to be a generic message to display to the user no matter if the payment
 * is successful or has errored. This is required in some payment providers such as
 * xpressbillpay where there's no wayh to handle errors and redirect the user to a more
 * appropiate error page.
 */
const PaymentCompleted = () => {
  const place = useSelector(selectConfigExpressSettingsName);
  const currentFlow = useSelector(selectCurrentFlow);
  const { isAbleToCloseWindow, closeWindow } = useCloseWindow();

  return (
    <GeneralPageLayout
      flow={currentFlow}
      next="Close Window"
      showNext={isAbleToCloseWindow}
      onNext={closeWindow}
    >
      <p>Thank you for your application.</p>
      <p>
        If you have cancelled your payment during the payment process, you will
        need to restart the application process from the beginning.
      </p>
      <p>
        If you have completed your payment, you will receive a receipt by email
        once your payment has been received. Thank you for submitting your
        application payment. Your actions today allow short-term rentals to be
        an attractive choice for {place} visitors, while maintaining the
        residential character of our neighbourhoods.
      </p>
    </GeneralPageLayout>
  );
};

export default PaymentCompleted;
